<template>
  <base-crud-page-list
      v-if="permissions.PROJECT_READ"
      :title="$tc('menu.project', 2)"
      :create-url="{ name: 'mainProjectsCreate' }"
      :create-show="permissions.PROJECT_CREATE"
      :footer-show="record.pageCount > 1"
  >
    <template #filter>
      <button @click="check" :disabled="createButtonLoading" v-if="permissions.PROJECT_CREATE"
              class="btn az_base_btn btn-primary mr-3"
              style="margin-bottom: 1rem">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"
             style="margin-right: 8px">
          <path
              d="M7.99967 1.33331C4.31967 1.33331 1.33301 4.31998 1.33301 7.99998C1.33301 11.68 4.31967 14.6666 7.99967 14.6666C11.6797 14.6666 14.6663 11.68 14.6663 7.99998C14.6663 4.31998 11.6797 1.33331 7.99967 1.33331ZM11.333 8.66665H8.66634V11.3333H7.33301V8.66665H4.66634V7.33331H7.33301V4.66665H8.66634V7.33331H11.333V8.66665Z"
              fill="white"/>
        </svg>
        {{ createButtonLoading ? $t('loading') : $t('create') }}
      </button>

      <base-input-search
          class="mr-3"
          is-filter
          @update:value="HandleParams('search', $event)"
      ></base-input-search>

      <base-input-group
          class="mr-3"
          is-filter
          :resource="groups"
          :show-organization="$store.state.userProfile.systemAdmin"
          @update:value=" HandleParams('group', $event)"
      ></base-input-group>

      <base-input-manager
          class="mr-3"
          is-filter
          :show-organization="$store.state.userProfile.systemAdmin"
          @update:value=" HandleParams('manager', $event)"
          :resource="manager"
      ></base-input-manager>
      <base-input-organization
          v-if="$store.state.userProfile.systemAdmin"
          is-filter
          @update:value=" HandleParams('organization', $event)"
      ></base-input-organization>
      <form @submit.prevent="submit">
        <div class="modal fade show nd_modal" id="project" role="dialog" aria-labelledby="exampleModalCenterTitle"
             aria-hidden="true" @click.self="clearModal">
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" @click="clearModal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body nd_modal_pages">
                <div class="nd_modal_block">

                  <div class="nd_create_item">
                    <p class="nd_p_text24 nd_color_black mb-1">{{ $t("newProject") }}</p>
                    <p class="nd_p_text14 nd_color_grey mb-4">{{ $t("singlyProject") }}</p>
                    <div class="nd_base_form_gr mb-3">
                      <img src="../../../../../public/img/people.png" alt="">
                      <select class="form-control nd_base_inp"
                              v-if="!edit && $store.state.userProfile.systemAdmin"
                              v-model="createProjectModel.uuid"
                              :class="[{'ftr': isFilter}, inputClass]"
                      >
                        <option :value="0">{{ $tc('menu.organization', 1) }}</option>
                        <option
                            v-for="item in organizationList" :value="item.id" :key="item.id"
                        >{{ item.name }}
                        </option>

                      </select>
                    </div>
                    <div class="nd_base_form_gr mb-3">
                      <img src="../../../../../public/img/task-square.png" alt="">
                      <input class="form-control nd_base_inp"
                             type="text"
                             :placeholder="$t('repoerts.boardName')"
                             v-model.trim="$v.createProjectModel.name.$model"
                             :class="{'is-invalid': $v.createProjectModel.name.$error}"
                      >
                    </div>
                    <div class="nd_base_form_gr mb-3">
                      <img src="../../../../../public/img/edit-2.png" alt="">
                      <input class="form-control nd_base_inp"
                             type="text"
                             :placeholder="$t('codeName')"
                             v-model.trim="$v.createProjectModel.codeName.$model"
                             :class="{'is-invalid': $v.createProjectModel.codeName.$error}"
                      >
                    </div>
                    <div class="nd_base_form_gr mb-3">
                      <img src="../../../../../public/img/people.png" alt="">
                      <select class="form-control nd_base_inp"
                              :class="{'is-invalid': $v.createProjectModel.group.id.$error}"
                              v-model="$v.createProjectModel.group.id.$model"
                      >
                        <option :value="0">{{ $tc('menu.team', 1) }}</option>
                        <option
                            v-for="item in group" :value="item.id" :key="item.name"
                        >{{ item.name }}
                        </option>

                      </select>
                    </div>
                    <div class="nd_base_form_gr mb-3">
                      <img src="../../../../../public/img/user-square.png" alt="">
                      <select class="form-control nd_base_inp"
                              v-model.trim="$v.createProjectModel.manager.id.$model"
                              :class="{'is-invalid': $v.createProjectModel.manager.id.$error}"
                      >
                        <option :value="0">{{ $t('managers') }}</option>
                        <option :key="item.id" v-if="item.roles.map(item => item.codeName  === 'MANAGER')"
                                v-for="item in manager" :value="item.id">
                          {{ item.firstName }} {{ item.lastName }} {{ item.middleName }}
                        </option>
                      </select>
                    </div>
                    <div class="nd_base_form_gr mb-5">
                      <label style="font-size: 14px">{{ $t('deadline') }}</label>
                      <datepicker
                          v-bind="{'disabled-dates': {to: oneDayBack}}"
                          v-model.trim="$v.createProjectModel.deadLine.$model"
                          :class="{'is-invalid': $v.createProjectModel.deadLine.$error}"
                          bootstrap-styling
                          :placeholder="$t('deadline')"
                          format="d.MM.yyyy"
                      ></datepicker>
                    </div>
                    <button :disabled="isButtonDisabled" @click="submit" class="btn btn-primary az_base_btn">
                      <svg class="mr-1" xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17"
                           fill="none">
                        <path
                            d="M8.00004 1.8335C4.32004 1.8335 1.33337 4.82016 1.33337 8.50016C1.33337 12.1802 4.32004 15.1668 8.00004 15.1668C11.68 15.1668 14.6667 12.1802 14.6667 8.50016C14.6667 4.82016 11.68 1.8335 8.00004 1.8335ZM11.3334 9.16683H8.66671V11.8335H7.33337V9.16683H4.66671V7.8335H7.33337V5.16683H8.66671V7.8335H11.3334V9.16683Z"
                            fill="white"/>
                      </svg>
                      {{ $t('createProject') }}
                    </button>
                  </div>
                  <div class="img_create">
                    <img src="../../../../../public/img/businessman-completing-task 3.png" alt="">
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div class="modal fade show nd_modal" id="managerNotFound" role="dialog" aria-labelledby="exampleModalCenterTitle"
           aria-hidden="true">
        <div style="max-width: 550px;" class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content" style="min-height: 320px">
            <div class="d-flex flex-column"
                 style="align-items: center; text-align: center; margin: 30px 40px; gap: 20px">
              <img src="/img/info_dtm.png"/>
              <h2>{{ $t('managerNotFound') }}</h2>
              <p>{{ $t('managerNotFoundDescription') }}</p>
              <div class="d-flex">
                <a href="https://cabinet.dt.uz/users" class="btn az_base_btn btn-primary mr-3">
                  {{ $t("attachManagerbtn") }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal fade show nd_modal" id="projectCantCreate" role="dialog"
           aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div style="max-width: 550px" class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="checkModalClose">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body nd_modal_pages" style="display: block">
              <div class="img_create">
                <img src="../../../../../public/img/businessman.png" alt="">
              </div>
              <div style="text-align: center">
                <h3 style="font-weight: 600" v-html="checkLimitiErrorTitle"></h3>
                <p class="pt-2" v-html="checkLimitErrorDescription"></p>
                <div class="pt-4" style="display: flex; justify-content: center; ">
                  <button class="btn az_base_btn btn-secondary mr-3 "
                          type="button" data-dismiss="modal" aria-label="Close"
                          style="margin-bottom: 1rem; color: #FFFFFF"
                          @click="checkModalClose"
                  >
                    {{ $t('close') }}
                  </button>
                  <a v-if="checkLimitButtonText && checkLimitButtonLink" class="btn az_base_btn btn-primary mr-3"
                     :href="checkLimitButtonLink">
                    {{ checkLimitButtonText }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal fade show nd_modal" id="teamNotFound" role="dialog"
           aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div style="max-width: 550px" class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content" style="min-height: 200px !important;">
            <div class="modal-body nd_modal_pages" style="display: block">
              <div class="img_create d-flex justify-content-center">
                <img src="../../../../../public/img/info_dtm.png" alt="">
              </div>
              <div style="text-align: center">
                <h3 style="font-weight: 600">{{ $t('teamNotFound') }}</h3>
                <p class="pt-2">{{ $t('teamNotFoundDesc') }}</p>
                <div class="pt-4" style="display: flex; justify-content: center; ">
                  <a class="btn az_base_btn btn-primary mr-3" href="/main/teams/index">
                    {{ $t('createTeam') }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>


    <template #table>
      <div class="nd_crud_table">
        <base-crud-table>

          <template #head>
            <tr>
              <th class="width-75 sort" @click=" HandleParams('sort', 'id')"
                  :class="{'active': params.sortBy === 'id'}">
                <div class="az_crud_tb_th">
                  <div class="txt">#</div>

                  <template v-if="params.sortBy === 'id'">
                    <i class="fa fa-angle-up" v-if="params.sortDirection === 'asc'"></i>
                    <i class="fa fa-angle-down" v-else></i>

                  </template>
                </div>
              </th>

              <th class="sort" @click=" HandleParams('sort', 'name')" :class="{'active': params.sortBy === 'name'}">
                <div class="az_crud_tb_th">
                  <div class="txt">{{ $t('nameProject') }}</div>

                  <template v-if="params.sortBy === 'name'">
                    <i class="fa fa-angle-up" v-if="params.sortDirection === 'asc'"></i>
                    <i class="fa fa-angle-down" v-else></i>
                  </template>
                </div>
              </th>

              <th class="sort" @click=" HandleParams('sort', 'group')" :class="{'active': params.sortBy === 'group'}">
                <div class="az_crud_tb_th">
                  <div class="txt">{{ $tc('menu.team', 1) }}</div>

                  <template v-if="params.sortBy === 'group'">
                    <i class="fa fa-angle-up" v-if="params.sortDirection === 'asc'"></i>
                    <i class="fa fa-angle-down" v-else></i>
                  </template>
                </div>
              </th>

              <th class="sort" @click=" HandleParams('sort', 'managerName')"
                  :class="{'active': params.sortBy === 'managerName'}">
                <div class="az_crud_tb_th">
                  <div class="txt">{{ $t('manager') }}</div>

                  <template v-if="params.sortBy === 'managerName'">
                    <i class="fa fa-angle-up" v-if="params.sortDirection === 'asc'"></i>
                    <i class="fa fa-angle-down" v-else></i>
                  </template>
                </div>
              </th>
              <th v-if="permissionGroup.INDIVIDUAL_USER" class="sort">
                <div class="az_crud_tb_th" style="padding-left: 5px">
                  <div class="txt">{{ $t('status') }}</div>

                </div>
              </th>


              <th class="sort" @click=" HandleParams('sort', 'percent')"
                  :class="{'active': params.sortBy === 'percent'}">
                <div class="az_crud_tb_th">
                  <div class="txt">{{ $t('percent') }}</div>

                  <template v-if="params.sortBy === 'percent'">
                    <i class="fa fa-angle-up" v-if="params.sortDirection === 'asc'"></i>
                    <i class="fa fa-angle-down" v-else></i>
                  </template>
                </div>
              </th>
              <th class="sort"
                  v-if="$store.state.userProfile.systemAdmin"
                  @click=" HandleParams('sort', 'uuid')"
                  :class="{'active': params.sortBy === 'uuid'}"
              >
                <div class="az_crud_tb_th">
                  <div class="txt">{{ $tc('menu.organization', 1) }}</div>

                  <template v-if="params.sortBy === 'uuid'">
                    <i class="fa fa-angle-up" v-if="params.sortDirection === 'asc'"></i>
                    <i class="fa fa-angle-down" v-else></i>
                  </template>
                </div>
              </th>

              <th class="sort width-50"
                  v-if="permissions.PROJECT_READ
							|| permissions.PROJECT_UPDATE
							|| permissions.PROJECT_DELETE"
              >
              </th>
            </tr>
          </template>

          <template #body v-if="record.list.length > 0">
            <tr class="bdr" v-for="(item, index) in record.list" :key="item.id">
              <td>
                <div class="az_crud_tb_txt" v-if="params.sortBy === 'id' && params.sortDirection === 'desc'">
                  {{ record.count - (params.page * params.perPage) - index }}
                </div>
                <div class="az_crud_tb_txt" v-else>
                  {{ (params.page * params.perPage) + (index + 1) }}
                </div>
              </td>

              <td>
                <div  style=" cursor: pointer;
      max-height: 60px;
      overflow: hidden;
      width: 200px;
      word-break: break-word;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;" class="az_crud_tb_txt"
                     @click="$router.push({ name: 'dashboard', params: { id: item.id } })">{{ item.name }}
                </div>
              </td>

              <td>
                <div class="az_crud_tb_txt"  style=" cursor: pointer;
      max-height: 60px;
      overflow: hidden;
      width: 200px;
      word-break: break-word;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;"
                     @click="$router.push({ name: 'dashboard', params: { id: item.id } })">{{ item.group.name }}
                </div>
              </td>

              <td>
                <div class="az_crud_tb_txt" style="cursor: pointer"
                     @click="$router.push({ name: 'dashboard', params: { id: item.id } })">{{ item.managerName }}
                </div>
              </td>
              <td v-if="permissionGroup.INDIVIDUAL_USER">
                <div v-if="item.owner"
                     style="background-color: rgba(185,230,185,0.21); color: #005500; display: inline-block; padding: 5px 10px; text-align: center; border-radius: 4px; font-weight: 600;">
                  {{ $t('own') }}
                </div>
                <div v-else
                     style="background-color: rgba(230,185,185,0.21); width: 130px; padding: 5px 10px; color: #550000; text-align: center; border-radius: 4px; font-weight: 600;">
                  {{ $t('invited') }}
                </div>
              </td>
              <td>
                <div class="az_crud_tb_prgs_bx" style="cursor: pointer"
                     @click="$router.push({ name: 'dashboard', params: { id: item.id } })"
                     v-if="item.projectType.value === $store.state.PROJECT_TYPE_KANBAN">
                  <div class="az_crud_tb_prgs_txt">{{ item.percent }}%</div>
                  <div class="progress az_crud_tb_prgs"
                       :class="{'default': item.percent === 0,'danger': item.percent > 0,'warning': item.percent > 50,'success': item.percent > 80}">
                    <div class="progress-bar" :style="{'width': item.percent + '%'}"></div>
                  </div>
                </div>
                <div class="az_crud_tb_txt" v-else-if="item.projectType.value === $store.state.PROJECT_TYPE_TRELLO">
                  {{ $t('notAvailable') }}
                </div>
              </td>

              <td v-if="$store.state.userProfile.systemAdmin">
                <div class="az_crud_tb_txt">{{ item.organizationName }}</div>
              </td>

              <td v-if="permissions.PROJECT_READ || permissions.PROJECT_UPDATE || permissions.PROJECT_DELETE">
                <div class="d-flex align-items-center nd_block_edit">
                  <router-link class="flex align-items-center  ml-5 mr-3"
                               v-if="permissions.PROJECT_READ"
                               :to="{ name: 'dashboard', params: { id: item.id } }">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M9.70492 6L8.29492 7.41L12.8749 12L8.29492 16.59L9.70492 18L15.7049 12L9.70492 6Z"
                            fill="#9EABBE"/>
                    </svg>
                  </router-link>

                  <div >
                    <div class="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path
                            d="M12 8C13.1 8 14 7.1 14 6C14 4.9 13.1 4 12 4C10.9 4 10 4.9 10 6C10 7.1 10.9 8 12 8ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10ZM12 16C10.9 16 10 16.9 10 18C10 19.1 10.9 20 12 20C13.1 20 14 19.1 14 18C14 16.9 13.1 16 12 16Z"
                            fill="#7A889B"/>
                      </svg>
                    </div>
                    <ul class="dropdown-menu">
                      <router-link class="nd_btn_edit dropdown-item"
                                   :to="{name: 'mainProjectsRead', params: { id: item.id }}"
                                   v-if="permissions.PROJECT_READ">
                        <i class="fa fa-eye"></i>
                        {{ $t('view') }}
                      </router-link>
                      <router-link class="nd_btn_edit dropdown-item"
                                   :to="{ name: 'mainProjectsUpdate', params: { id: item.id } }"
                                   v-if="permissions.PROJECT_UPDATE && item.owner">
                        <i class="fa fa-pencil"></i>
                        {{ $t('edit') }}
                      </router-link>
                      <li class="nd_btn_delete nd_btn_edit dropdown-item"
                          v-if="permissions.PROJECT_DELETE && item.owner"
                          @click="showDeleteModal(item.id)"
                      >
                        <i class="fa fa-trash-o "></i>
                        {{ $t('delete') }}
                      </li>
                    </ul>
                  </div>

                  <div class="modal fade modal_column" :class="{'show':isDeleteModal}">
                    <div class="modal-dialog modal-dialog-centered">
                      <div class="modal-content delete-confirm-modal">
                        <div class="modal-header">
                          <h5 class="modal-title">{{ $t('areYouSure') }} </h5>
                          <button class="close" type="button" @click="isDeleteModal = false" data-dismiss="modal">
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div class="modal-body">
                          <p style="color: #ff0000" class="az_task_delete_txt">{{ $t('confirmDeleteProject') }}</p>
                        </div>

                        <div class="d-flex justify-content-center p-3 modal-footer">
                          <button class="btn az_base_btn btn-default button-effect" type="button" data-dismiss="modal"
                                  @click="isDeleteModal = false">{{ $t('cancel') }}
                          </button>
                          <button class="btn az_base_btn btn-danger button-effect" type="button" @click="Delete">
                            {{ $t('delete') }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </template>

        </base-crud-table>
        <div class="modal fade show nd_modal" id="projectCantDelete" role="dialog"
             aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
          <div style="max-width: 550px" class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                        @click="checkModalDeleteClose">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body" style="display: block">
                <div class="d-flex justify-content-center">
                  <img src="../../../../../public/img/svg/empty-state-concept.svg"/>
                </div>
                <h3 class="text-center my-2">{{ deleteData.title }}</h3>
                <p class="text-center ">{{ deleteData.description }}</p>
              </div>
              <div style="gap: 10px" class="modal-footer mt-5 d-flex justify-content-center">
                <button class="btn az_base_btn btn-primary mr-3" type="button" data-dismiss="modal" aria-label="Close"
                        @click="checkModalDeleteClose">
                  {{ $t('close') }}
                </button>
                <a class="btn az_base_btn btn-danger mr-3" :href="deleteData.redirect_url">
                  {{ $t('move') }}
                </a>
              </div>
            </div>
          </div>
        </div>
        <!--        <base-crud-range :value="params.perPage" @input="new HandleParams('range', $event)"></base-crud-range>-->
      </div>

    </template>


    <template #pagination>
      <paginate
          container-class="pagination az_base_pag"
          page-class="page-item"
          prev-class="page-item"
          next-class="page-item"
          page-link-class="page-link"
          prev-link-class="page-link"
          next-link-class="page-link"
          prev-text="&laquo;"
          next-text="&raquo;"
          :page-count="record.pageCount"
          :value="params.page + 1"
          @input="HandleParams('page', $event)"
      ></paginate>
    </template>

  </base-crud-page-list>
</template>

<script>
import BaseCrudPageList from '../../../../components/BaseCrudPageList';
import BaseCrudTable from '../../../../components/BaseCrudTable';
import BaseInputSearch from '../../../../components/BaseInputSearch';
import BaseCrudRange from '../../../../components/BaseCrudRange';
import BaseInputOrganization from '../../../../components/BaseInputOrganization';
import BaseInputGroup from '../../../../components/BaseInputGroup';
import BaseInputManager from '../../../../components/BaseInputManager';
import BaseInputProjectType from '../../../../components/BaseInputProjectType';
import Paginate from 'vuejs-paginate';
import Datepicker from 'vuejs-datepicker';
import {required} from "vuelidate/lib/validators";
import FormService from "@/services/FormService";
import axios from "axios";

const notZero = (value) => +value !== 0;
// eslint-disable-next-line no-undef
const today = new Date(moment().format('DD-MM-YYYY'));
const modal = document.getElementById('modal');
export default {
  name: 'ProjectsList',
  props: {
    value: {
      type: String,
      default: '',
    },
    ProjectName: {
      type: String,
      default: '',
    },
    inputClass: {
      type: [String, Object, Array],
      default: null,
    },
    isFilter: {
      type: Boolean,
      default: false,
    },
    edit: {
      type: Boolean,
      default: false,
    },
    $error: {
      type: [String, Object, Array],
      default: null,
    },
  },
  components: {
    BaseInputProjectType,
    BaseInputManager,
    BaseInputGroup,
    BaseInputOrganization,
    BaseCrudRange,
    BaseInputSearch,
    BaseCrudTable,
    BaseCrudPageList,
    Paginate,
    Datepicker,
  },
  data() {
    return {
      isSuccess: false,
      managerNotFoundModal: false,
      permissionGroup: {},
      permissions: {
        PROJECT_READ: true,
      },
      isButtonDisabled: false,
      checkEnum: 'PROJECT',
      checkLimitErrorDescription: "",
      createButtonLoading: false,
      checkLimitiErrorTitle: "",
      checkLimitButtonText: '',
      checkLimitButtonLink: "",
      createProjectModel: new FormService({
        name: '',
        codeName: '',
        projectType: 'KANBAN',
        group: {
          id: 0
        },
        manager: {
          id: 0
        },
        uuid: null,
        deadLine: null
      }),
      params: {
        page: 0,
        perPage: 10,
        sortBy: 'createdAt',
        sortDirection: 'desc',
        allSearch: null,
        groupId: null,
        managerId: null,
        projectKanban: null,
        projectTrello: null,
        uuid: null,
      },
      record: {
        list: [],
        count: 0,
        pageCount: 0,
      },
      startDisabledDates: {
        to: today
      },
      deleteData: {},
      projectList: null,
      group: [],
      manager: [],
      isDeleteModal: false,
      uuid: null,
      organizationList: this.resource,
      deadLine: this.resource,
    };
  },
  validations() {
    let options = {
      createProjectModel: {
        name: {
          required
        },
        codeName: {
          required,
        },
        group: {
          id: {
            notZero
          }
        },
        deadLine: {
          required
        },
        manager: {
          id: {
            notZero
          }
        },
      },
    };
    if (!this.edit) {
      if (this.$store.state.userProfile.systemAdmin) {
        options.createProjectModel.uuid = {
          notZero,
        };
      }
    }
    return options;

  },
  watch: {

    'createProjectModel.uuid'(val) {
      if (this.$store.state.userProfile.systemAdmin) {
        if (!this.edit) {
          this.createProjectModel.group.id = 0;
          this.group = [];
          this.params.allSearch = null;


          this.createProjectModel.manager.id = 0;
          this.manager = [];
        }

        this.getGroupAll(val);
        this.getManagerAll();
      }
    },
    'deadlineDate'(val) {
      this.deadlineDateFormatted = this.$moment(val).isValid() ? this.$moment(val).format('D.MM.YYYY') : null;
    },

    'createProjectModel'(val) {
      this.organizationList = val;
    },
  },
  created() {
    if (!this.external) {
      this.GetList();
    }
  },

  mounted() {
    if (!this.$store.state.userProfile.systemAdmin) {
      this.getGroupAll();
      this.getManagerAll();
    }
    $('#project').on('show.bs.modal', () => {
      this.isButtonDisabled = false;

    });
  },
  methods: {
    createdDate() {
      let momentDate = +this.$moment().subtract(1, 'days');
      let date = new Date(momentDate)
      this.deadlineDisabledDates.to = date
      this.startDisabledDates.to = date
    },
    resetValidator() {
      this.$v.$reset()
    },
    submit() {
      this.isButtonDisabled = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.isButtonDisabled = false;
        return;
      }
      this.$store.state.loader = true;
      this.save()
          .then(() => {
            this.$emit('emit:submit');
            this.isButtonDisabled = false;
          })
          .catch(() => {
            this.isButtonDisabled = false;
          });
    },
    HandleParams(type, val) {
      switch (type) {
        case 'search':
          this.params.allSearch = val ? val : null;
          break;

        case 'group':
          this.params.groupId = val === 0 ? null : val;
          break;

        case 'manager':
          this.params.managerId = val === 0 ? null : val;
          break;

        case 'type':
          this.params.projectKanban = val === 'KANBAN' ? true : null;
          this.params.projectTrello = val === 'TRELLO' ? true : null;
          break;

        case 'range':
          this.params.perPage = val;
          break;

        case 'page':
          window.scrollTo({top: 0, behavior: "smooth"})
          this.params.page = val - 1;
          break;

        case 'sort':
          if (this.params.sortBy === val) {
            this.params.sortDirection = this.params.sortDirection === 'asc' ? 'desc' : 'asc';
          }
          this.params.sortBy = val;
          break;

        case 'organization':
          this.params.uuid = val === 0 ? null : val;
          break;
      }

      if (type !== 'page') {
        this.params.page = 0;
      }

      this.GetList();
    },
    GetList() {
      if (!this.group) {
        this.$api
            .get('groups')
            .then(response => {
              this.group = response.data.data;
            });
      }

      this.$api
          .get('projects/percentage', {
            params: this.params,
          })
          .then(response => {
            this.record.list = response.data.data;
            this.record.count = response.data.totalCount;
            this.permissions = response.data.permissions
            this.record.pageCount = Math.ceil(response.data.totalCount / this.params.perPage);
          });
    },
    getGroupAll(uuid = this.$store.state.userProfile.id) {
      this.$api
          .get('groups', {
            params: {
              uuid: uuid,
            }
          })
          .then(response => {
            this.group = response.data.data;
            this.permissionGroup = response.data.permissions
          });
    },
    // eslint-disable-next-line no-unused-vars
    async getManagerAll() {
      try {
        const response = await this.$api.get('employees', {
          params: {
            isManager: true
          }
        });

        this.manager = response.data.data;
      } catch (error) {
        this.$notification.error(error.response.data.error_message.title)
      }
    },
    showDeleteModal(id) {
      this.projectId = id;
      this.isDeleteModal = true
      $('#modalDeleteProjects').modal('show')
    },
    Delete() {
      this.$api
          .delete('projects/' + this.projectId)
          // eslint-disable-next-line no-unused-vars
          .then(() => {
            this.isDeleteModal = false
            this.$notification.success(this.$t('successfullyDeleted'));
            this.GetList();
            $('#modalDeleteProjects').modal('hide');
            this.projectId = null;
          }).catch(error => {
        $('#projectCantDelete').modal('show')
        // this.$notification.error(error.response.data.error_message.description);
        this.deleteData = error.response.data.error_message;
        this.isDeleteModal = false
      });
    },
    RouteUpdateProject(item) {
      this.$router.push({
        name: 'mainProjectsUpdate',
        params: {
          id: item.id,
        }
      })
    },
    RouteReadProject(item) {
      this.$router.push({
        name: 'mainProjectsRead',
        params: {
          id: item.id,
        }
      })
    },
    save() {
      return this.$api
          .post('projects', this.createProjectModel.GetData())
          .then(() => {
            this.$router.push({ name: 'mainProjects' });
            this.$notification.success(this.$t('SuccessfullyCreated'));
            this.clearModal();
            this.GetList();
          })
          .catch(error => {
            this.$notification.error(error.response.data.error_message.title);
            throw error; // Ensure the catch block in submit() is triggered
          });
    },
    checkModalDeleteClose() {
      $('#projectCantDelete').modal('hide')
    },
    checkModalClose() {
      $('#projectCantCreate').modal('hide')
    },
    managerNotFoundModalClose() {
      $('#managerNotFound').modal('hide')
    },
    clearModal() {
      this.isButtonDisabled = false;
      this.$store.state.loader = false;

      this.createProjectModel.Reset()
      this.resetValidator()
      $("#project").modal('hide')
    },
    async check() {
      if (!this.group.length) {
        $("#teamNotFound").modal('show')
      } else if (!this.manager.length) {
        $('#managerNotFound').modal('show')
      } else {
        try {
          this.createButtonLoading = true;
          const {data} = await this.$api
              .post('check-limit', this.checkEnum)
          if (data.success) {
            $('#project').modal('show')
            return
          }
        } catch (e) {
          $('#projectCantCreate').modal('show')
          const {title, description, redirect_url, button} = e.response.data.error_message
          this.checkLimitiErrorTitle = title
          this.checkLimitErrorDescription = description
          this.checkLimitButtonText = button
          this.checkLimitButtonLink = redirect_url
        } finally {
          this.createButtonLoading = false
        }
      }
    },
  },
  computed: {
    groups() {
      return this.group
    },
    oneDayBack() {
      // eslint-disable-next-line no-undef
      const date = new Date()
      date.setHours(0)
      date.setMinutes(0)
      date.setSeconds(0)
      return date
    },
    // eslint-disable-next-line vue/no-dupe-keys
    createProjectModelComputed: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('update:value', +val);
      }
    }
  },
};
</script>
